module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-header navbar hidden-print",
    attrs: {
      "id": "header",
      "role": "menu"
    }
  }, [_c('div', {
    staticClass: "navbar-header bg-black "
  }, [_c('button', {
    directives: [{
      name: "click-out",
      rawName: "v-click-out",
      value: (_vm.hideNavbarCollapse),
      expression: "hideNavbarCollapse"
    }],
    staticClass: "pull-right visible-xs dk",
    attrs: {
      "target": ".navbar-collapse"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggleNavbarCollapse($event)
      }
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-cog"
  })]), _vm._v(" "), _c('button', {
    staticClass: "pull-right visible-xs",
    attrs: {
      "ui-toggle-class": "off-screen",
      "target": ".app-aside",
      "ui-scroll": "app"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggleMenu($event)
      }
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-align-justify"
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand text-lt",
    attrs: {
      "to": {
        name: 'dashboard.main'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/logo_min.png"),
      "alt": "Logo"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-folded m-l-xs font-normal"
  }, [_vm._v("ERP")])])], 1), _vm._v(" "), _c('div', {
    ref: "navbarCollapse",
    staticClass: "collapse pos-rlt navbar-collapse box-shadow bg-white-only",
    class: {
      show: _vm.navbarCollapse
    }
  }, [_c('div', {
    staticClass: "nav navbar-nav hidden-xs"
  }, [_c('a', {
    staticClass: "btn no-shadow navbar-btn",
    on: {
      "click": function($event) {
        return _vm._menuFolded(true, 1)
      }
    }
  }, [(!_vm.menuFolded) ? _c('i', {
    staticClass: "fa fa-dedent fa-fw text"
  }) : _vm._e(), _vm._v(" "), (_vm.menuFolded) ? _c('i', {
    staticClass: "fa fa-indent fa-fw"
  }) : _vm._e()])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav hidden-sm"
  }, [(_vm.ACL.check('restrito_visitante', _vm.currentUser.id)) ? _c('DDNew') : _vm._e()], 1), _vm._v(" "), _c('Search'), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li'), _vm._v(" "), _c('Notification'), _vm._v(" "), _c('Profile')], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd0c615e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/_default/components/Header.vue
// module id = 1855
// module chunks = 17